import { PersonDetail } from '../../../types/personDetail';
import { InfoColumn, PersonChip } from '../../shared';

export const getPersonInfoColumns = (personDetail: PersonDetail): InfoColumn[] => {
  return [
    // Column 1: Family Members
    {
      fields: [
        {
          label: 'Family Members',
          value: personDetail.familyMembers && personDetail.familyMembers.length > 0 ? (
            <div className="flex flex-wrap gap-2">
              {personDetail.familyMembers.map((member) => (
                <PersonChip 
                  key={member.id}
                  id={member.id}
                  name={member.name}
                  relationship={member.relationship}
                  avatarUrl={member.avatarUrl}
                />
              ))}
            </div>
          ) : (
            <span className="text-gray-400 text-sm">None recorded</span>
          ),
        },
      ],
    },
    // Column 2: Primary Campus & Giving ID
    {
      fields: [
        ...(personDetail.primaryCampus 
          ? [{
              label: 'Primary Campus',
              value: personDetail.primaryCampus,
            }]
          : []
        ),
        ...(personDetail.givingId 
          ? [{
              label: 'Giving ID',
              value: personDetail.givingId,
            }]
          : []
        ),
      ],
    },
    // Column 3: Address & Demographics
    {
      fields: [
        ...(personDetail.gender 
          ? [{
              label: 'Gender',
              value: personDetail.gender,
            }]
          : []
        ),
        ...(personDetail.birthday 
          ? [{
              label: 'Birthday',
              value: personDetail.birthday,
            }]
          : []
        ),
      ],
    },
  ];
};
